import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import PlayerBar from '../components/PlayerBar/index';
import OfflineNotice from '../components/OfflineNotice';
import { usePlayerStore } from '../stores/playerStore';
import { useTheme } from '../contexts/ThemeContext';

const MainLayout: React.FC = () => {
  const { currentStation } = usePlayerStore();
  const { mode } = useTheme();

  return (
    <div className={`min-h-screen ${mode === 'fairy'
      ? 'theme-fairy'
      : mode === 'neon'
        ? 'theme-neon bg-black'
        : 'bg-background'
      }`}>
      <Header />
      <OfflineNotice />
      <main className="flex-1 mt-16 mb-24 overflow-y-auto">
        <Outlet />
      </main>
      {currentStation && (
        <div className="fixed bottom-0 left-0 right-0 z-40">
          <PlayerBar />
        </div>
      )}
    </div>
  );
};

export default MainLayout;